import React from "react";
import PageLayout from "../../ui/PageLayout";
import PageHero from "../../ui/PageHero";
import VideoEmbed from "../../ui/VideoEmbed";
import FadeIn from "../../ui/FadeIn";

const GoBananas = () => (
  <PageLayout>
    <PageHero title="Go Bananas" light />
    <section className="ku-section bg-white">
      <div className="ku-container max-w-4xl">
        <FadeIn>
          <div className="ku-prose mb-10">
            <p>
              In early April, &apos;19 while the world was going bananas with the rumours of the ongoing pandemic catching fire; we at KU realised that with the nationwide lockdown, things were going to get only tougher.
            </p>
            <p>
              So, we reached out to Mr Shishir Joshi, founder of the NGO- Project Mumbai. Project Mumbai had already been doing some amazing work on the ground & they, along with the Holy Cross School of Kurla, quickly became our execution partners to help us find a way to distribute-
            </p>
            <p>
              5000 bananas each day to the children of daily wage earners, migrant workers and slum dwellers all across Mumbai.
            </p>
          </div>
        </FadeIn>
        <FadeIn delay={0.1}>
          <VideoEmbed src="https://www.youtube.com/embed/ZbKKCG-VUig" title="Go Bananas" />
        </FadeIn>
        <FadeIn delay={0.15}>
          <div className="ku-prose mt-10">
            <p>
              Thereafter, we launched a crowdfunding campaign on Milap. Kind people like you, helped us close our crowdfunding goal of Rs 3,00,000 and more!
              <br />
              With a gradual increase in the donations received, we could reach out to more & more children, with these nutritious gifts of kindness.
            </p>
            <p>
              Thanks to contributions from kind people like You, a whooping 1,25,000+ bananas were distributed via this kindness project!
              <br />
              Truly, Go Bananas was indeed a one of a kind virtual service project that witnessed the power of collaboration & the ripple effect of going bananas- with one&apos;s kindness!
            </p>
          </div>
        </FadeIn>
      </div>
    </section>
  </PageLayout>
);

export default GoBananas;
